import { render } from "./QuickbooksPage.vue?vue&type=template&id=f2097678&scoped=true"
import script from "./QuickbooksPage.vue?vue&type=script&lang=js"
export * from "./QuickbooksPage.vue?vue&type=script&lang=js"

import "./QuickbooksPage.vue?vue&type=style&index=0&id=f2097678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2097678"]])

export default __exports__